// Moderne Landingpages (Vorlage: src/pages/PremiumLanding.js). Neue Seite = JSON-Datei hier + Eintrag in dieser Liste.
import seoKmu from './seo-kmu.json';
import handwerker from './handwerker.json';
import websiteErstellen from './website-erstellen-lassen.json';
import googleProfil from './google-unternehmensprofil.json';
import arztpraxen from './arztpraxen.json';
import websiteCheck from './website-check.json';
import automatisierung from './automatisierung-fuer-kmu.json';
import kiWinterthur from './ki-automatisierung-winterthur.json';

export const LANDINGPAGES = [websiteErstellen, seoKmu, handwerker, googleProfil, arztpraxen, websiteCheck, automatisierung, kiWinterthur];
